import { AuthService } from '../../core/auth.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DSMessage, DSMessageAPI } from '../../models/api/ds-message';
import { filter, map } from 'rxjs/operators';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class DsMessageService {
  dsMessagesUrl = environment.baseUrl + environment.api + 'ds_messages';

  constructor(private http: HttpClient, private authService: AuthService) {}

  loadLastMessage(): Observable<DSMessage> {
    return this.http
      .get<DSMessageAPI>(this.dsMessagesUrl, {
        headers: this.authService.getJwtAuthHeaders(),
      })
      .pipe(
        filter((dsMessage) => dsMessage.id !== 0),
        map((dsMessage) => {
          return {
            ...dsMessage,
            title: JSON.parse(dsMessage.title),
            message: JSON.parse(dsMessage.message),
            createdAt: moment(dsMessage.createdAt).toDate(),
            validTo: moment(dsMessage.validTo).toDate(),
          };
        })
      );
  }
}
